/** Build full path for featured category page. pageUrl is stored as slug (e.g. "kkwa") → returns "/fc/kkwa" */
export const getFeaturedCategoryPath = (pageUrl) => {
  if (!pageUrl || typeof pageUrl !== "string") return "/fc/all-products";
  const slug = pageUrl.replace(/^\//, "").replace(/^fc\/?/, "").trim();
  return slug ? `/fc/${slug}` : "/fc/all-products";
};

export const queryToUrl = (params) => {
  return params.replace(/&/g, "AND").replace(/ /g, "_");
};

export const urlToQuery = (url) => {
  if (typeof url !== 'string') {
    if (url instanceof URLSearchParams) {
      return url.toString().replace(/AND/g, "&").replace(/_/g, " ");
    }
    console.warn('urlToQuery received non-string input:', url);
    return '';
  }
  return url.replace(/AND/g, "&").replace(/_/g, " ");
};

export const setUrl = (path, searchParams, query, value, check) => {
  return `${path}?${
    query === "category"
      ? value
        ? "category=" + value + "&"
        : ""
      : searchParams.get("category")
      ? "category=" + searchParams.get("category") + "&"
      : ""
  }${
    query === "priceRange"
      ? check
        ? "min=" + value.min + "&" + "max=" + value.max + "&"
        : ""
      : searchParams.get("min")
      ? "min=" +
        searchParams.get("min") +
        "&" +
        "max=" +
        searchParams.get("max") +
        "&"
      : ""
  }${
    query === "shippingTime"
      ? value
        ? "shippingTime=" + value + "&"
        : ""
      : searchParams.get("shippingTime")
      ? "shippingTime=" + searchParams.get("shippingTime") + "&"
      : ""
  }${
    query === "search"
      ? "search=" + value + "&"
      : searchParams.get("search")
      ? "search=" + searchParams.get("search") + "&"
      : ""
  }${
    query === "amazonFriendly"
      ? value
        ? "amazonFriendly=" + value + "&"
        : ""
      : searchParams.get("amazonFriendly")
      ? "amazonFriendly=" + searchParams.get("amazonFriendly") + "&"
      : ""
  }${
    query === "shopifyFriendly"
      ? value
        ? "shopifyFriendly=" + value + "&"
        : ""
      : searchParams.get("shopifyFriendly")
      ? "shopifyFriendly=" + searchParams.get("shopifyFriendly") + "&"
      : ""
  }${
    query === "shippingCountry"
      ? value
        ? "shippingCountry=" + value + "&"
        : ""
      : searchParams.get("shippingCountry")
      ? "shippingCountry=" + searchParams.get("shippingCountry") + "&"
      : ""
  }${
    query === "sortBy"
      ? value !== "recommended"
        ? "sortBy=" + value + "&"
        : ""
      : searchParams.get("sortBy")
      ? "sortBy=" + searchParams.get("sortBy") + "&"
      : ""
  }${searchParams.get("fcId") ? "fcId=" + searchParams.get("fcId") + "&" : ""}${
    searchParams.get("ali") ? "ali=" + searchParams.get("ali") + "&" : ""
  }${
    searchParams.get("t") ? "t=" + searchParams.get("t") + "&" : ""
  }${
    searchParams.get("page") ? "page=" + searchParams.get("page") : ""
  }`;
};

export const setQueryParams = (searchParams) => {
  return `?${
    searchParams.get("category")
      ? "categoryName=" +
        encodeURIComponent(urlToQuery(searchParams.get("category")))
      : ""
  }${
    searchParams.get("search")
      ? "&search=" + encodeURIComponent(urlToQuery(searchParams.get("search")))
      : ""
  }${
    searchParams.get("min") && searchParams.get("max")
      ? "&min=" +
        encodeURIComponent(searchParams.get("min")) +
        "&max=" +
        encodeURIComponent(searchParams.get("max"))
      : ""
  }${
    searchParams.get("shippingTime")
      ? "&shippingTime=" + encodeURIComponent(searchParams.get("shippingTime"))
      : ""
  }${
    searchParams.get("amazonFriendly")
      ? "&amazonFriendly=" +
        encodeURIComponent(searchParams.get("amazonFriendly"))
      : ""
  }${
    searchParams.get("shopifyFriendly")
      ? "&shopifyFriendly=" +
        encodeURIComponent(searchParams.get("shopifyFriendly"))
      : ""
  }${
    searchParams.get("shippingCountry")
      ? "&shippingCountry=" +
        encodeURIComponent(searchParams.get("shippingCountry"))
      : ""
  }${
    searchParams.get("sortBy")
      ? "&sortBy=" + encodeURIComponent(searchParams.get("sortBy"))
      : ""
  }${
    searchParams.get("fcId")
      ? "&fcId=" + encodeURIComponent(searchParams.get("fcId"))
      : ""
  }${
    searchParams.get("page")
      ? "&page=" + encodeURIComponent(searchParams.get("page"))
      : "&page=" + 1
  }`;
};

export const createMarkup = (html) => {
  return { __html: html };
};

/**
 * Show the restricted search popup (same UX as search bar's containsRestrictedSequence block).
 * Use when search is blocked or API returns 400 for restricted/invalid content.
 */
export const showRestrictedSearchPopup = () => {
  if (!document.getElementById("restricted-popup-style")) {
    const style = document.createElement("style");
    style.id = "restricted-popup-style";
    style.innerHTML = `
      .restricted-popup {
        position: fixed;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
        background: #fff;
        border-radius: 8px;
        padding: 12px 16px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        z-index: 99999;
        transition: opacity .3s ease, transform .3s ease;
        opacity: 0;
        pointer-events: none;
      }
      .restricted-popup.show { opacity: 1; transform: translateX(-50%) translateY(0); pointer-events: auto; }
      .restricted-popup-content { font-size: 14px; color: #222; }
      .restricted-progress { width: 160px; height: 6px; background: #eee; border-radius: 3px; overflow: hidden; margin-top:8px; }
      .restricted-progress-bar { width: 100%; height: 100%; background: #f97316; transition: width 2.8s linear; }
    `;
    document.head.appendChild(style);
  }
  const popup = document.createElement("div");
  popup.className = "restricted-popup";
  popup.innerHTML = `
    <div class="restricted-popup-content">
      🚫 Search contains restricted content.
      <div class="restricted-progress"><div class="restricted-progress-bar"></div></div>
    </div>
  `;
  document.body.appendChild(popup);
  setTimeout(() => popup.classList.add("show"), 30);
  setTimeout(() => {
    const bar = popup.querySelector(".restricted-progress-bar");
    if (bar) bar.style.width = "0%";
  }, 50);
  setTimeout(() => {
    popup.classList.remove("show");
    setTimeout(() => popup.remove(), 300);
  }, 3000);
};
